
export const enum PlanStatus {
    Draft = 1,
    Published = 2,
    Started = 3,
    Complete = 4,
    Abandoned = 5
}
